<script setup lang="ts">
import frpicker from 'emoji-picker-element/i18n/fr'
import { ChevronsUpDown } from 'lucide-vue-next'

import useEmojiPickerInput from './useEmojiPickerInput'

defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', emoji: string): void
}>()

const emojiPickerLoaded = ref(false)
const open = ref(false)
const fr = frpicker
const { emojiSelected, form } = useEmojiPickerInput()

const onEmojiClick = (event: Event) => {
  emojiSelected(event as CustomEvent, () => (open.value = false))
  emit('update:modelValue', form.emoji)
}

onMounted(async () => {
  if (typeof window === 'undefined') return

  const module: any = await import('emoji-picker-element')
  const EmojiPickerElement = module.default || module

  if (!customElements.get('emoji-picker')) {
    customElements.define('emoji-picker', EmojiPickerElement)
  }
  emojiPickerLoaded.value = true
})
</script>

<template>
  <Popover v-model:open="open">
    <PopoverTrigger as-child>
      <Button variant="outline" class="text-2xl">
        {{ modelValue }}
        <ChevronsUpDown class="text-muted-foreground" />
      </Button>
    </PopoverTrigger>

    <PopoverContent class="w-auto border-0 bg-transparent p-0 shadow-none" align="start">
      <emoji-picker v-if="emojiPickerLoaded" class="light" :i18n="fr" locale="fr" @emoji-click="onEmojiClick" />
    </PopoverContent>
  </Popover>
</template>
